import styled from 'styled-components';

export const ClientSettingsDropdownToggleCheckboxBox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;

  width: 100%;
  height: 45px;
`;